'use client';
import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function PdfLeadMagnetSection() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ name: '', email: '' });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.name || !form.email) return;
    // Backend integration point: POST to /api/leads with { name, email, source: 'pdf_download' }
    setSubmitted(true);
  };

  return (
    <section
      id="pdf-download"
      className="py-20 px-6"
      style={{ background: '#F4F3EF' }}
    >
      <div className="max-w-5xl mx-auto">
        <div
          className="rounded-sm overflow-hidden grid md:grid-cols-2"
          style={{ border: '1px solid rgba(11,29,58,0.12)' }}
        >
          {/* Left — dark navy panel */}
          <div
            className="p-10 flex flex-col justify-between"
            style={{
              background: 'linear-gradient(135deg, #0B1D3A 0%, #0E2347 100%)',
            }}
          >
            <div>
              <div
                className="w-12 h-12 rounded-sm flex items-center justify-center mb-6"
                style={{ background: 'rgba(184,148,62,0.15)', border: '1px solid rgba(184,148,62,0.3)' }}
              >
                <Icon name="DocumentArrowDownIcon" variant="outline" size={22} className="text-gold" />
              </div>
              <p className="text-[10px] font-semibold tracking-widest2 uppercase text-gold/60 mb-3">
                Complimentary Publication
              </p>
              <h3
                className="font-serif font-light text-marble mb-4"
                style={{ fontSize: 'clamp(1.4rem, 2.5vw, 2rem)', lineHeight: '1.2' }}
              >
                2024 Bank Regulatory Outlook
              </h3>
              <p className="text-[12px] text-marble/50 leading-relaxed">
                Statute partners analyze the year&apos;s most consequential OCC guidance, Basel III endgame updates, CFPB enforcement trends, and state licensing shifts — with practical implications for institutions from $500M to $50B in assets.
              </p>
            </div>

            {/* Contents list */}
            <div className="mt-8 space-y-3">
              {[
                '2024 OCC Examination Priorities',
                'Basel III Endgame: Capital Planning Implications',
                'CFPB Enforcement: 12-Month Pattern Analysis',
                'Fintech Charter Landscape: State-by-State',
                'BSA/AML: Emerging Compliance Obligations',
              ].map((item) => (
                <div key={item} className="flex items-start gap-2.5">
                  <Icon name="ChevronRightIcon" variant="outline" size={13} className="text-gold mt-0.5 flex-shrink-0" />
                  <span className="text-[11px] text-marble/55 tracking-wide">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right — form panel */}
          <div
            className="p-10 flex flex-col justify-center"
            style={{ background: '#FAFAF7' }}
          >
            {!submitted ? (
              <>
                <h4
                  className="font-serif text-navy mb-2"
                  style={{ fontSize: '1.4rem' }}
                >
                  Download the Report
                </h4>
                <p className="text-[12px] text-navy/50 mb-7 leading-relaxed">
                  No sales calls. No follow-up without your consent. Your information is governed by attorney-client privilege standards.
                </p>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-[10px] font-semibold tracking-widest uppercase text-navy/50 mb-1.5">
                      Full Name
                    </label>
                    <input
                      type="text"
                      value={form.name}
                      onChange={(e) => setForm({ ...form, name: e.target.value })}
                      placeholder="Margaret Chen"
                      className="w-full px-4 py-3 text-[13px] text-navy rounded-sm"
                      style={{
                        background: 'white',
                        border: '1px solid rgba(11,29,58,0.15)',
                        outline: 'none',
                        transition: 'border-color 0.2s',
                      }}
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-[10px] font-semibold tracking-widest uppercase text-navy/50 mb-1.5">
                      Work Email
                    </label>
                    <input
                      type="email"
                      value={form.email}
                      onChange={(e) => setForm({ ...form, email: e.target.value })}
                      placeholder="m.chen@firstmidwest.com"
                      className="w-full px-4 py-3 text-[13px] text-navy rounded-sm"
                      style={{
                        background: 'white',
                        border: '1px solid rgba(11,29,58,0.15)',
                        outline: 'none',
                        transition: 'border-color 0.2s',
                      }}
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full btn-red py-3.5 text-[11px] font-semibold tracking-widest uppercase rounded-sm mt-2"
                  >
                    Download Free Report
                  </button>
                </form>
                <p className="text-[10px] text-navy/30 mt-4 leading-relaxed">
                  By submitting, you agree to receive communications from Statute LLP. Attorney advertising. Prior results do not guarantee similar outcomes.
                </p>
              </>
            ) : (
              <div className="text-center py-8">
                <div
                  className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5"
                  style={{ background: 'rgba(184,148,62,0.1)', border: '1px solid rgba(184,148,62,0.3)' }}
                >
                  <Icon name="CheckIcon" variant="outline" size={24} className="text-gold" />
                </div>
                <h4 className="font-serif text-navy text-xl mb-2">Report Sent</h4>
                <p className="text-[12px] text-navy/50 leading-relaxed">
                  Check your inbox. A partner will be available if you have questions about the analysis.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}